import { Component } from "react";
import TileArcGISRest from "ol/source/TileArcGISRest";
import olTileLayer from "ol/layer/Tile";
import VectorSource from "ol/source/Vector";
import GeoJSON from "ol/format/GeoJSON";
import VectorLayer from "ol/layer/Vector";
import { bbox as bboxStrategy } from 'ol/loadingstrategy';
import Style from 'ol/style/Style';
import Stroke from 'ol/style/Stroke';
import Fill from 'ol/style/Fill';


function Progress(el) {
  this.el = el;
  this.loading = 0;
  this.loaded = 0;
}


class ParcelOverlay extends Component {

  state = {
    tileSource: null
  };

  componentDidMount() {

  }

  componentDidUpdate() {
    let { map } = this.props;
    let { tileSource } = this.state;

    if(!tileSource) {

      const parcelVectorSource = new VectorSource({
        format: new GeoJSON({
          dataProjection: 'EPSG:3857', // Assuming the coordinates are in Web Mercator (EPSG:3857)
          featureProjection: 'EPSG:3857' // The projection of the map (Web Mercator)
        }),
        url: function (extent) {
          return window.clipship_config.ParcelsLayerUrl + extent.join(',');
        },
        strategy: bboxStrategy
      });

      
      // Vector layer
      const vectorLayer = new VectorLayer({
        source: parcelVectorSource,
        minZoom: 17,
        style: new Style({
          stroke: new Stroke({
            color: 'rgb(255, 145, 0)',
            width: 1
          }),
          fill: new Fill({color: 'rgba(0, 0, 0, 0)'})
        })
      });
      
      map.addLayer(vectorLayer);

      map.on('moveend', function () {
        parcelVectorSource.refresh();
      });

    }
  };

  render() {
    return false;
  }
}


export default ParcelOverlay;
